export default __webpack_public_path__ + "static/media/IMG_5581.7ccc69fd.jpg";